<script setup>
import { computed, ref, useSlots, onMounted, defineExpose } from 'vue'

const slots = useSlots()
const stack = ref([])
const buttons = ref([])

onMounted(() => {
  // Al montar, si hay un slot por defecto, lo agregamos a la pila
  if (slots.default) {
    const defaultComponent = {
      render() {
        return slots.default()
      }
    }
    stack.value.push({component: defaultComponent})
  }
})

const currentView = computed(() => stack.value[stack.value.length - 1] ?? null)
const canGoBack = computed(() => stack.value.length > 1)

function push(component, props = {}) {
  stack.value.push({ component, props });
}

function pop() {
  if (canGoBack.value) stack.value.pop()
}

function setButtons(newButtons) {
  buttons.value = newButtons
}

defineExpose({ push, pop, setButtons  })
</script>

<template>
  <div class="min-h-full">
    <div class="w-full h-[48px] flex items-center sticky top-0 bg-zinc-100 dark:bg-zinc-800 z-10">
      <button v-if="canGoBack" @click="pop" class="flex items-center font-semibold">
        <img class="dark:invert" src="img/back.png"/>
        Regresar
      </button>
      <div class="ml-auto flex justify-center">
          <!-- Renderizamos los botones desde el ref -->
          <component v-for="(btn, i) in buttons" :is="btn" :key="i" />
      </div>
    </div>
    <transition name="slide" mode="out-in"> 
      <div class="h-full bg-zinc-100 dark:bg-zinc-800" v-if="currentView" :key="stack.length">
        <component
          :is="currentView?.component"
          v-if="currentView"
          :key="stack.length"
          v-bind="currentView.props"
        />
      </div>
    </transition >
  </div>
</template>

<style scoped>
  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.4s ease;
  }

  .slide-enter-from {
    transform: translateX(100%);
  }

  .slide-enter-to {
    transform: translateX(0);
  }

  .slide-leave-from {
    transform: translateX(0);
  }

  .slide-leave-to {
    transform: translateX(100%);
  }
</style>
